import React from 'react';

import { getCompletedVolumes } from '../../../../../../viewer/elements/volume/utils';
import { useAssetsStore } from '../../../state/assets-store';
import { sortVolumesByAssetType, sortVolumesByDate, VolumeWithAsset } from './utils';

const alwaysTrueFilter = (_: VolumeWithAsset) => true;

export const useVolumesWithAssets = (
  filter: (asset: VolumeWithAsset) => boolean = alwaysTrueFilter,
) => {
  const { assets } = useAssetsStore();
  const initial = React.useMemo(
    () =>
      assets
        .flatMap((a) => getCompletedVolumes(a))
        .filter(filter)
        .sort(sortVolumesByDate)
        .sort(sortVolumesByAssetType),
    [assets, filter],
  );
  const [volumesWithAssets, setVolumesWithAssets] = React.useState<VolumeWithAsset[]>(initial);

  // Update volumesWithAssets when initial changes
  React.useEffect(() => {
    setVolumesWithAssets((prev) =>
      // If the lengths are the same and the volumes are the same, return the previous state.      prev.length === initial.length &&
      prev.every((p, i) => p.id === initial[i].id && p.asset.uuid === initial[i].asset.uuid)
        ? prev
        : initial,
    );
  }, [initial]);

  return { volumesWithAssets, setVolumesWithAssets };
};
